export interface Video {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  category: string;
  duration: string;
  views: string;
  rating: string;
  quality: string;
  date: string;
}

export const categories: string[] = [
  '全部',
  '电视剧',
  '电影',
  '综艺',
  '动漫',
  '纪录片',
  '短视频',
  '体育',
  '音乐',
  '游戏',
];

export const videos: Video[] = [
  {
    id: 'v1',
    title: '长安十二时辰',
    description: '古装悬疑巨制，易烊千玺与雷佳音联手破获惊天阴谋，精彩不容错过',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20scene%20with%20palace%20background%2C%20warm%20cinematic%20lighting%2C%20Tang%20dynasty%20aesthetic%2C%20dramatic%20composition%2C%20rich%20colors%2C%20movie%20poster%20style&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    category: '电视剧',
    duration: '45:00',
    views: '1.2亿',
    rating: '9.1',
    quality: '4K',
    date: '2026-08-01',
  },
  {
    id: 'v2',
    title: '流浪地球3',
    description: '科幻史诗巨作，人类命运共同体携手拯救太阳系，视觉效果震撼人心',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20space%20station%20and%20Earth%20in%20background%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20epic%20cinematic%20composition%2C%20movie%20poster%20style%2C%20high%20contrast&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    category: '电影',
    duration: '148:00',
    views: '3.5亿',
    rating: '9.4',
    quality: '4K',
    date: '2026-07-15',
  },
  {
    id: 'v3',
    title: '奔跑吧兄弟 第十二季',
    description: '国民综艺欢乐回归，明星嘉宾爆笑挑战，让你笑到停不下来',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20game%20scene%20with%20colorful%20obstacles%2C%20bright%20cheerful%20lighting%2C%20group%20of%20celebrities%20running%2C%20fun%20energetic%20composition%2C%20summer%20vibe&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    category: '综艺',
    duration: '90:00',
    views: '2.8亿',
    rating: '8.9',
    quality: '1080P',
    date: '2026-08-05',
  },
  {
    id: 'v4',
    title: '斗罗大陆 绝世唐门',
    description: '热血动漫全新篇章，霍雨浩觉醒武魂开启传奇修炼之路',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20fantasy%20scene%20with%20martial%20arts%20character%20in%20ancient%20Chinese%20setting%2C%20magical%20energy%20effects%2C%20vibrant%20colors%2C%20dynamic%20action%20pose%2C%20illustration%20style&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    category: '动漫',
    duration: '22:00',
    views: '4.2亿',
    rating: '9.6',
    quality: '1080P',
    date: '2026-08-06',
  },
  {
    id: 'v5',
    title: '舌尖上的中国 第五季',
    description: '深入全国各地探寻最地道的美食文化，记录人与食物的温情故事',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20cuisine%20documentary%20scene%20with%20steaming%20hot%20food%20on%20wooden%20table%2C%20warm%20natural%20lighting%2C%20rustic%20kitchen%20background%2C%20appetizing%20composition%2C%20close-up%20food%20photography&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    category: '纪录片',
    duration: '50:00',
    views: '1.8亿',
    rating: '9.3',
    quality: '4K',
    date: '2026-06-20',
  },
  {
    id: 'v6',
    title: '喜剧之王争霸赛',
    description: '全国顶尖喜剧人同台竞技，爆笑段子源源不断，承包你一整年的笑点',
    thumbnail: 'https://readdy.ai/api/search-image?query=Comedy%20show%20stage%20with%20spotlight%20and%20colorful%20stage%20design%2C%20comedian%20performing%2C%20warm%20theater%20lighting%2C%20lively%20atmosphere%2C%20entertainment%20show%20poster%20style&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    category: '综艺',
    duration: '75:00',
    views: '1.5亿',
    rating: '8.7',
    quality: '1080P',
    date: '2026-08-03',
  },
  {
    id: 'v7',
    title: '封神第二部',
    description: '神话史诗巨制续作，姜子牙率众神讨伐商纣，特效全面升级',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20scene%20with%20ancient%20Chinese%20warriors%20and%20gods%2C%20dramatic%20sky%20with%20lightning%2C%20epic%20battle%20composition%2C%20cinematic%20lighting%2C%20movie%20poster%20style&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    category: '电影',
    duration: '155:00',
    views: '2.2亿',
    rating: '8.8',
    quality: '4K',
    date: '2026-05-10',
  },
  {
    id: 'v8',
    title: '足球之夜：欧冠决赛特辑',
    description: '全程跟踪欧冠决赛幕后故事，球星专访与战术深度解析',
    thumbnail: 'https://readdy.ai/api/search-image?query=Soccer%20stadium%20night%20match%20scene%20with%20dramatic%20stadium%20lights%2C%20green%20field%2C%20action%20moment%2C%20sports%20photography%20style%2C%20atmospheric%20lighting&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    category: '体育',
    duration: '60:00',
    views: '8900万',
    rating: '9.0',
    quality: '4K',
    date: '2026-07-28',
  },
  {
    id: 'v9',
    title: '中国好声音 2026',
    description: '全新导师阵容震撼亮相，挖掘华语乐坛最强新声力量',
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20talent%20show%20stage%20with%20colorful%20spotlights%20and%20rotating%20chairs%2C%20singer%20performing%20with%20microphone%2C%20dramatic%20stage%20lighting%2C%20concert%20atmosphere%2C%20show%20poster%20style&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    category: '音乐',
    duration: '100:00',
    views: '1.6亿',
    rating: '8.5',
    quality: '1080P',
    date: '2026-08-02',
  },
  {
    id: 'v10',
    title: '英雄联盟全球总决赛回顾',
    description: '重温LPL战队夺冠征程，热血时刻全记录，电竞爱好者必看',
    thumbnail: 'https://readdy.ai/api/search-image?query=E-sports%20arena%20with%20massive%20LED%20screens%20and%20cheering%20crowd%2C%20gaming%20tournament%20stage%2C%20colorful%20neon%20lighting%2C%20grand%20stadium%20atmosphere%2C%20dynamic%20composition&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    category: '游戏',
    duration: '55:00',
    views: '2.5亿',
    rating: '9.2',
    quality: '4K',
    date: '2026-07-20',
  },
  {
    id: 'v11',
    title: '庆余年 第三季',
    description: '范闲回归京都风云再起，权谋与武侠交织的精彩故事，口碑爆棚',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20palace%20scene%20with%20elegant%20costumes%2C%20ancient%20Chinese%20architecture%20background%2C%20warm%20cinematic%20lighting%2C%20dramatic%20character%20pose%2C%20period%20drama%20poster%20style&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    category: '电视剧',
    duration: '50:00',
    views: '2.1亿',
    rating: '9.5',
    quality: '4K',
    date: '2026-08-04',
  },
  {
    id: 'v12',
    title: '搞笑短视频合集 第50期',
    description: '精选全网最搞笑短视频，萌宠、搞笑、整蛊一网打尽，解压神器',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20pets%20and%20people%20compilation%20collage%20style%2C%20bright%20colorful%20background%2C%20happy%20vibrant%20atmosphere%2C%20entertainment%20thumbnail%20style%2C%20playful%20composition&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    category: '短视频',
    duration: '15:00',
    views: '5.6亿',
    rating: '9.0',
    quality: '1080P',
    date: '2026-08-07',
  },
];

export const hotVideos = videos.slice(0, 6);

export const latestVideos = [...videos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 8);